class DefaultSpacing {
  #defaultPaddingX;
  #defaultPaddingY;
  #defaultGap;
  #defaultScale;

  constructor() {
    this.#defaultPaddingX = "px-[4vw] md:px-[6.5vw]";
    this.#defaultPaddingY = "py-[3rem] md:py-[6rem]";
    this.#defaultGap = "gap-5 lg:gap-12";
    this.#defaultScale = 1.05;
  }

  getDefaultPaddingX() {
    return this.#defaultPaddingX;
  }
  getDefaultPaddingY() {
    return this.#defaultPaddingY;
  }
  getDefaultGap() {
    return this.#defaultGap;
  }
  getDefaultScale() {
    return this.#defaultScale;
  }
}

export default DefaultSpacing;
